<template>
  <div id="documents">
    <Breadcrumbs
      :crumbs="[
        { name: globals.info.school_name, link: `${pathPrefix}/` },
        { name: sectionName, link: `${pathPrefix}/documents` },
      ]"
    />
    <div class="page-container">
      <DocumentBreadcrumbs :crumbs="[{ name: sectionName, link: `${pathPrefix}/documents` }]" />
      <DocumentList
        :content="foldersAndDocuments"
        :is-fetching="isFetching"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useDocumentsData } from '../../composables/useDocumentsData';
import Breadcrumbs from '../../components/global/Breadcrumbs.vue';
import DocumentList from '../../components/DocumentList.vue';
import DocumentBreadcrumbs from '../../components/global/DocumentBreadcrumbs.vue';
import { useNuxtApp, useHead } from '#imports';

defineOptions({
  name: 'Documents',
});

const store = useStore();
const { $t } = useNuxtApp();

store.dispatch('setCustomSectionData', {
  type: 'documents',
  fallbackSectionName: $t('pages.documents.sectionName'),
});

const globals = computed(() => store.state.globals);
const pathPrefix = computed(() => store.state.pathPrefix);
const sectionName = computed(() => store.state.sectionName);

useHead({
  title: sectionName.value,
});

const { isFetching, foldersAndDocuments } = useDocumentsData();
</script>
